import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1202.000000 1280.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)">

<path d="M5767 11630 c-52 -107 -177 -361 -277 -565 -282 -571 -430 -876 -430
-885 0 -4 63 -135 141 -291 78 -156 163 -329 189 -384 26 -55 173 -352 325
-660 153 -308 330 -668 395 -800 203 -415 359 -733 637 -1295 148 -300 318
-645 378 -767 l109 -223 106 0 c94 0 109 2 125 20 23 25 40 25 71 1 23 -18 48
-19 661 -14 351 2 641 5 645 6 4 1 -36 88 -87 192 -52 105 -181 368 -288 585
-107 217 -290 589 -407 825 -117 237 -297 601 -400 810 -662 1340 -1017 2055
-1135 2285 -63 124 -291 588 -378 770 -25 52 -99 205 -165 340 l-120 245 -95
-195z m313 -860 c16 0 35 7 44 15 8 8 24 15 36 15 22 0 80 -50 80 -69 0 -6 8
-11 19 -11 14 0 21 -10 25 -35 7 -35 27 -57 34 -37 8 26 22 10 22 -25 0 -42 6
-53 35 -69 16 -9 23 -8 32 5 12 14 15 13 34 -11 11 -16 26 -28 33 -28 11 0 56
-79 56 -99 0 -8 -25 -7 -50 2 -8 3 -42 8 -75 10 -46 4 -82 17 -155 55 -214
110 -250 132 -250 151 0 8 -11 26 -24 40 -14 15 -28 39 -32 54 -6 24 -4 28 12
26 29 -4 61 10 69 29 6 16 7 16 16 0 6 -11 22 -18 39 -18z m105 -434 c0 -32
-23 -53 -49 -43 -19 7 -21 48 -4 65 7 7 22 11 33 10 15 -2 20 -11 20 -32z
m130 -123 c64 -24 67 -47 7 -51 -44 -3 -137 22 -148 39 -24 39 51 46 141 12z
m-51 -528 c29 -26 32 -45 15 -78 -24 -44 -58 -49 -94 -12 -29 28 -32 61 -9 93
20 29 55 28 88 -3z m170 -1 c7 -19 -10 -44 -31 -44 -17 0 -27 24 -19 45 7 20
42 19 50 -1z m-129 -164 c0 -33 -40 -41 -50 -11 -9 28 2 43 28 39 16 -2 22
-10 22 -28z m295 6 c0 -29 -33 -44 -55 -26 -21 17 -1 50 30 50 20 0 25 -5 25
-24z m170 -106 c26 -14 34 -58 15 -86 -32 -49 -125 -25 -125 31 0 12 9 34 20
48 21 26 50 28 90 7z m-705 -19 c3 -5 1 -12 -5 -16 -5 -3 -10 1 -10 9 0 18 6
21 15 7z m556 -307 c10 -13 10 -17 -2 -25 -25 -15 -39 -10 -39 16 0 28 21 33
41 9z m-141 -329 c15 -18 10 -45 -12 -59 -13 -8 -22 -6 -37 8 -25 23 -26 30
-5 50 19 20 38 20 54 1z m-290 -61 c0 -16 -26 -19 -35 -4 -3 6 -4 14 0 20 8
13 35 1 35 -16z m1074 -140 c8 -21 -1 -34 -25 -34 -12 0 -19 7 -19 18 0 34 33
45 44 16z m386 -440 c0 -8 -4 -12 -10 -9 -5 3 -10 10 -10 16 0 5 5 9 10 9 6 0
10 -7 10 -16z m-262 -12 c2 -7 -6 -12 -17 -12 -21 0 -27 11 -14 24 9 9 26 2
31 -12z m362 -521 c0 -10 -7 -22 -16 -25 -23 -9 -24 -8 -24 19 0 18 5 25 20
25 13 0 20 -7 20 -19z m-596 -317 c6 -17 -9 -44 -25 -44 -12 0 -31 39 -24 50
10 16 42 12 49 -6z m966 -359 c0 -8 -7 -15 -15 -15 -8 0 -15 7 -15 15 0 8 7
15 15 15 8 0 15 -7 15 -15z m-310 -230 c0 -8 -4 -15 -9 -15 -13 0 -22 16 -14
24 11 11 23 6 23 -9z m-212 -69 c6 -31 -43 -50 -54 -21 -8 20 15 47 35 43 9
-2 17 -12 19 -22z m-341 -43 c12 -17 11 -23 -6 -44 -16 -20 -23 -22 -47 -14
-22 8 -30 18 -32 40 -7 54 53 67 85 18z m941 1 c4 -25 -22 -49 -43 -40 -22 8
-29 34 -14 52 17 21 53 14 57 -12z m-1218 -55 c0 -5 -4 -9 -10 -9 -5 0 -10 7
-10 16 0 8 5 12 10 9 6 -3 10 -10 10 -16z m1350 -49 c0 -15 -30 -32 -45 -26
-18 7 -20 33 -2 39 16 5 47 -3 47 -13z m-540 -15 c15 -18 5 -35 -20 -35 -10 0
-22 5 -25 10 -7 11 12 40 25 40 4 0 13 -7 20 -15z m-376 -188 c16 -12 16 -14
-2 -30 -22 -21 -52 -13 -52 13 0 16 11 26 31 29 3 1 13 -5 23 -12z m990 -12
c7 -20 -27 -38 -42 -23 -7 7 -12 18 -12 25 0 18 47 16 54 -2z m-214 -254 c0
-14 -18 -23 -30 -16 -6 4 -8 11 -5 16 8 12 35 12 35 0z"/>
<path d="M6485 10451 c-3 -5 -1 -12 5 -16 5 -3 10 1 10 9 0 18 -6 21 -15 7z"/>
<path d="M4250 8507 c-993 -2002 -1223 -2463 -1249 -2500 -92 -135 -174 -324
-207 -477 -28 -130 -25 -366 5 -485 102 -396 361 -650 745 -729 95 -20 303
-20 411 -1 67 12 304 15 1488 15 774 0 1407 2 1407 4 0 2 -40 89 -89 192 -49
104 -111 238 -139 297 -39 81 -55 107 -68 105 -9 -2 -19 3 -22 11 -3 10 0 12
12 8 9 -4 16 -2 16 2 0 10 -34 86 -109 244 -28 59 -51 109 -51 111 0 2 -31 68
-69 147 -37 79 -85 181 -106 227 l-38 82 -145 0 c-80 0 -265 4 -411 10 -448
16 -611 17 -611 3 0 -7 -7 -13 -15 -13 -8 0 -15 7 -15 15 0 12 -15 15 -78 15
-154 0 -412 13 -412 21 0 5 32 75 71 156 39 81 100 207 134 278 34 72 100 207
145 300 90 186 177 368 247 513 24 52 77 160 117 242 41 81 77 156 80 167 4
13 -6 48 -28 94 -18 41 -67 148 -109 239 -41 91 -125 275 -187 410 -62 135
-138 301 -169 370 -32 69 -100 217 -151 330 -51 113 -94 206 -95 207 -1 2
-138 -273 -305 -610z m280 407 c0 -8 -5 -12 -10 -9 -6 4 -8 11 -5 16 9 14 15
11 15 -7z m18 -890 c43 -30 23 -96 -34 -110 -53 -14 -98 71 -58 110 20 20 63
20 92 0z m446 -282 c2 -4 1 -14 -4 -22 -7 -11 -12 -12 -21 -3 -6 6 -8 16 -5
22 8 13 23 14 30 3z m206 -87 c0 -8 -9 -15 -20 -15 -11 0 -20 7 -20 15 0 8 9
15 20 15 11 0 20 -7 20 -15z m-1299 -45 c24 -13 24 -42 0 -64 -23 -21 -49 -12
-62 23 -8 20 -7 28 7 38 22 16 30 16 55 3z m873 -716 c22 -22 20 -51 -5 -65
-24 -13 -83 -6 -105 12 -19 16 -18 46 4 58 26 16 89 13 106 -5z m-359 -19 c14
-13 25 -33 25 -43 0 -31 -38 -70 -77 -81 -31 -9 -42 -7 -69 10 -18 11 -36 28
-39 39 -7 22 27 82 52 92 39 15 84 8 108 -17z m-639 -176 c10 -17 -13 -36 -27
-22 -12 12 -4 33 11 33 5 0 12 -5 16 -11z m11 -685 c7 -19 -18 -38 -28 -22 -9
14 0 38 12 38 5 0 12 -7 16 -16z m423 -14 c0 -23 -13 -32 -34 -24 -22 8 -20
42 2 47 24 5 32 -1 32 -23z m1578 -342 c-4 -27 -33 -36 -42 -13 -8 22 1 35 25
35 15 0 20 -6 17 -22z m-2400 -34 c12 -4 29 -19 37 -34 13 -24 13 -30 0 -40
-24 -20 -72 -3 -83 30 -7 19 -7 31 1 39 13 13 14 13 45 5z m2567 -24 c8 -26
-1 -40 -29 -40 -32 0 -58 22 -50 43 9 25 71 23 79 -3z m-2467 -157 c-5 -25
-28 -28 -28 -4 0 12 6 21 16 21 9 0 14 -7 12 -17z m1632 1 c0 -11 -5 -14 -16
-10 -9 3 -18 6 -20 6 -3 0 -2 5 1 10 10 16 35 12 35 -6z m587 -50 l20 -27 -27
-29 c-27 -29 -28 -29 -59 -14 -21 12 -31 24 -31 40 0 31 19 46 72 55 3 0 15
-11 25 -25z m276 -26 c12 -6 36 -12 52 -12 36 -1 42 -29 8 -34 -12 -2 -25 -12
-28 -23 -8 -26 -34 -24 -70 5 -27 21 -28 26 -17 50 13 29 23 32 55 14z m-562
-116 c7 -18 3 -29 -16 -48 -29 -29 -49 -30 -75 -4 -26 26 -25 54 1 79 19 18
25 18 52 8 16 -7 34 -23 38 -35z m-1943 -29 c-4 -22 -22 -20 -26 1 -2 10 3 16
13 16 10 0 15 -7 13 -17z m880 -32 c21 -13 10 -46 -16 -49 -27 -4 -40 22 -22
43 14 17 20 18 38 6z m1522 -12 c0 -5 -7 -9 -15 -9 -15 0 -20 12 -9 23 8 8 24
-1 24 -14z m299 -42 c13 -16 5 -27 -21 -27 -18 0 -25 20 -11 33 10 10 19 8 32
-6z m-949 -47 c0 -5 -4 -10 -9 -10 -6 0 -13 5 -16 10 -3 6 1 10 9 10 9 0 16
-4 16 -10z m786 -79 c-11 -18 -36 -13 -36 7 0 10 3 22 7 26 10 10 37 -20 29
-33z m-31 -155 c0 -22 -14 -29 -34 -17 -19 12 -6 43 16 39 10 -2 18 -12 18
-22z m-1965 -141 c0 -9 11 -21 25 -27 26 -12 31 -23 15 -33 -5 -3 -18 3 -30
15 -11 11 -26 20 -34 20 -15 0 -28 24 -19 34 12 12 43 6 43 -9z m1700 -35
c-21 -13 -44 8 -28 27 10 12 14 12 27 -2 14 -14 14 -17 1 -25z m660 -180 c0
-5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m300
-58 c0 -13 -12 -22 -22 -16 -10 6 -1 24 13 24 5 0 9 -4 9 -8z"/>
<path d="M7432 5379 c2 -4 41 -77 88 -163 l85 -155 1452 -1 1451 0 -79 141
c-43 78 -79 144 -79 148 0 5 -8 15 -17 23 -16 14 -170 16 -1461 15 -793 0
-1441 -4 -1440 -8z m1633 -74 c0 -22 -31 -33 -47 -17 -17 17 -1 44 24 40 15
-2 23 -10 23 -23z"/>
<path d="M7790 4647 c0 -2 25 -50 56 -108 31 -57 71 -130 88 -161 l31 -58 923
0 c507 0 922 3 922 6 0 8 -158 294 -172 311 -8 10 -171 13 -713 13 -618 0
-703 -2 -709 -15 -7 -19 -36 -20 -36 0 0 13 -28 15 -195 15 -107 0 -195 -1
-195 -3z m150 -122 c0 -8 -7 -15 -15 -15 -8 0 -15 7 -15 15 0 8 7 15 15 15 8
0 15 -7 15 -15z"/>
<path d="M5097 3683 c-4 -3 -7 -388 -7 -855 l0 -848 90 0 90 0 0 120 c0 73 4
120 10 120 6 0 10 -4 10 -9 0 -19 107 -125 158 -158 81 -52 154 -74 267 -80
277 -14 491 132 581 397 15 44 19 85 19 210 0 137 -3 163 -24 225 -57 166
-178 296 -332 355 -30 11 -95 26 -145 32 -168 22 -332 -30 -442 -139 -32 -32
-68 -71 -80 -88 l-21 -30 -1 378 0 377 -83 0 c-46 0 -87 -3 -90 -7z m755 -664
c182 -61 288 -222 288 -439 0 -187 -89 -336 -246 -411 -115 -54 -275 -50 -395
12 -201 102 -285 393 -179 618 32 66 103 149 157 182 97 60 261 77 375 38z"/>
<path d="M6577 3630 c-33 -29 -37 -37 -37 -82 0 -88 38 -128 121 -128 97 0
143 128 75 206 -17 20 -34 28 -72 31 -46 5 -54 2 -87 -27z"/>
<path d="M8002 3632 c-80 -75 -36 -212 68 -212 77 0 120 42 120 120 0 77 -43
120 -119 120 -29 0 -47 -7 -69 -28z"/>
<path d="M1623 3388 c-109 -241 -300 -669 -353 -788 -21 -47 -90 -202 -154
-344 -64 -142 -116 -263 -116 -267 0 -5 42 -9 93 -9 l93 0 90 205 89 205 440
0 441 0 28 -67 c16 -38 45 -102 64 -143 18 -41 45 -103 59 -137 l25 -63 99 0
c54 0 99 3 99 6 0 3 -29 69 -64 147 -100 223 -245 546 -276 617 -16 36 -64
144 -108 240 -43 96 -121 271 -173 387 l-94 213 -96 0 -95 0 -91 -202z m358
-398 c67 -151 137 -310 155 -352 l33 -78 -364 0 -364 0 33 78 c94 218 317 726
323 735 8 13 30 -33 184 -383z"/>
<path d="M7210 3463 c-1 -5 -2 -75 -3 -158 l-2 -150 -87 -3 -88 -3 0 -69 0
-69 88 -3 87 -3 5 -415 5 -415 27 -51 c82 -156 275 -197 476 -102 40 19 62 35
62 46 0 18 -32 107 -41 117 -3 3 -36 -6 -73 -20 -98 -37 -189 -33 -232 10 -6
6 -20 27 -30 45 -17 32 -19 65 -22 412 l-3 378 193 2 193 3 3 67 3 68 -193 2
-193 3 -3 158 -3 157 -84 0 c-47 0 -85 -3 -85 -7z"/>
<path d="M3291 3185 c-104 -19 -188 -63 -253 -134 -30 -32 -61 -73 -71 -92
-16 -34 -17 -33 -17 99 l0 132 -90 0 -90 0 0 -605 0 -605 85 0 c80 0 85 1 90
23 3 12 6 177 8 367 3 384 3 382 76 491 70 103 179 160 311 162 148 2 255 -58
309 -173 l26 -55 3 -407 3 -408 89 0 89 0 3 353 c4 330 5 356 26 418 57 172
189 270 367 272 130 1 213 -35 275 -120 63 -86 64 -89 68 -526 l3 -398 87 3
87 3 0 415 c0 453 -3 478 -58 583 -94 179 -321 257 -557 191 -126 -36 -228
-117 -285 -226 l-29 -57 -32 69 c-58 124 -156 198 -301 226 -89 17 -124 17
-222 -1z"/>
<path d="M8905 3185 c-139 -26 -240 -80 -330 -177 -59 -63 -112 -159 -136
-243 -19 -67 -19 -293 0 -360 42 -152 164 -301 301 -369 258 -126 599 -63 766
142 170 208 189 527 46 751 -85 134 -230 228 -396 256 -105 18 -156 18 -251 0z
m210 -155 c126 -21 246 -109 303 -223 26 -52 52 -162 52 -223 1 -180 -98 -346
-247 -417 -65 -31 -74 -32 -188 -32 -148 0 -203 19 -291 99 -101 91 -144 195
-144 346 0 142 44 256 129 339 100 97 235 136 386 111z"/>
<path d="M10421 3185 c-131 -24 -245 -98 -313 -204 l-28 -45 0 127 0 127 -90
0 -90 0 0 -605 0 -605 90 0 90 0 0 348 c0 382 3 406 61 508 37 66 96 119 168
153 51 24 67 26 176 26 111 0 124 -2 170 -27 95 -50 147 -124 165 -234 6 -33
10 -220 10 -416 l0 -358 90 0 90 0 0 403 c-1 441 -5 481 -58 590 -58 116 -170
195 -309 216 -89 14 -128 13 -222 -4z"/>
<path d="M6560 2585 l0 -605 90 0 90 0 0 605 0 605 -90 0 -90 0 0 -605z"/>
<path d="M7990 2585 l0 -606 88 3 87 3 0 600 0 600 -87 3 -88 3 0 -606z"/>
<path d="M2440 1410 l0 -290 30 0 c28 0 30 2 30 41 l0 41 39 -35 c47 -42 105
-55 171 -37 138 37 187 230 86 338 -48 52 -80 65 -152 60 -53 -3 -70 -9 -104
-36 l-40 -33 0 121 0 120 -30 0 -30 0 0 -290z m286 51 c57 -35 82 -136 49
-200 -27 -54 -71 -81 -128 -81 -94 0 -147 57 -147 158 0 55 29 108 70 129 38
19 120 16 156 -6z"/>
<path d="M4143 1683 c-21 -8 -15 -51 8 -63 26 -14 49 3 49 35 0 29 -26 41 -57
28z"/>
<path d="M5254 1676 c-3 -8 -4 -25 -2 -38 2 -18 9 -23 33 -23 28 0 30 3 30 35
0 31 -3 35 -28 38 -17 2 -29 -2 -33 -12z"/>
<path d="M9610 1675 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7
-30 -15z"/>
<path d="M1485 1651 c-51 -26 -75 -66 -75 -124 0 -75 40 -110 184 -157 80 -26
116 -57 116 -97 0 -93 -132 -121 -256 -54 -54 29 -54 29 -66 8 -26 -49 114
-114 225 -104 109 10 179 86 162 176 -11 57 -58 94 -167 130 -102 34 -138 62
-138 105 1 70 111 98 220 57 49 -19 51 -19 60 -1 16 29 13 35 -27 55 -24 11
-68 20 -118 22 -66 4 -87 1 -120 -16z"/>
<path d="M7253 1663 c-12 -2 -36 -17 -53 -33 -39 -36 -41 -91 -6 -161 l25 -48
-32 -20 c-66 -40 -82 -67 -82 -133 0 -56 2 -62 37 -93 69 -64 158 -64 240 -1
19 14 39 26 44 26 4 0 27 -18 49 -40 35 -34 44 -39 54 -27 9 12 2 23 -35 59
l-46 45 31 55 c28 49 30 57 16 68 -18 15 -17 16 -44 -37 -12 -24 -27 -43 -33
-43 -7 0 -38 26 -70 57 -56 56 -74 93 -43 93 8 0 35 19 60 43 40 39 45 48 45
88 0 36 -6 51 -28 72 -27 26 -85 40 -129 30z m99 -50 c29 -26 24 -84 -9 -115
-30 -27 -65 -48 -82 -48 -19 0 -51 63 -51 99 0 50 33 81 83 81 24 0 48 -7 59
-17z m-28 -299 c69 -74 69 -74 50 -95 -29 -32 -69 -49 -114 -49 -89 0 -144 73
-109 143 15 30 70 77 89 75 8 0 46 -34 84 -74z"/>
<path d="M7943 1650 c-23 -12 -50 -33 -59 -48 -23 -34 -22 -110 1 -145 18 -29
87 -65 177 -93 72 -22 102 -52 102 -101 0 -89 -149 -111 -264 -38 -23 15 -43
25 -45 23 -1 -2 -8 -13 -14 -25 -11 -21 -8 -25 34 -52 86 -55 197 -65 278 -26
61 29 91 93 76 164 -11 52 -46 78 -154 117 -55 19 -110 45 -122 56 -28 26 -30
68 -4 99 27 34 130 39 196 10 50 -22 58 -20 69 15 9 31 -51 56 -149 61 -67 4
-87 1 -122 -17z"/>
<path d="M4950 1575 c0 -54 0 -55 -30 -55 -25 0 -30 -4 -30 -25 0 -20 5 -25
24 -25 31 0 36 -19 36 -161 0 -128 10 -154 67 -178 39 -16 107 7 111 37 3 19
0 20 -50 15 -51 -5 -54 -4 -66 21 -7 16 -12 74 -12 146 l0 120 65 0 c63 0 65
1 65 25 0 24 -2 25 -65 25 l-65 0 0 55 c0 52 -1 55 -25 55 -24 0 -25 -3 -25
-55z"/>
<path d="M6605 1530 c-78 -12 -105 -40 -105 -110 0 -54 27 -81 111 -109 81
-27 109 -46 109 -75 0 -61 -108 -83 -185 -37 -30 17 -40 19 -46 9 -17 -26 -8
-39 38 -60 67 -30 116 -34 168 -14 57 22 85 57 85 107 0 52 -40 90 -120 114
-94 28 -127 62 -101 103 14 23 73 30 131 15 43 -11 55 -11 62 -1 15 24 8 35
-29 46 -57 17 -75 18 -118 12z"/>
<path d="M10848 1530 c-52 -9 -84 -34 -98 -75 -10 -30 -9 -41 7 -73 15 -31 28
-41 78 -60 112 -42 130 -54 133 -90 3 -29 0 -34 -34 -48 -45 -19 -105 -12
-153 17 -27 16 -36 18 -42 7 -16 -24 -9 -38 29 -57 123 -63 262 -15 262 89 0
51 -42 91 -121 115 -100 31 -133 70 -90 109 22 20 84 23 135 6 19 -6 40 -9 46
-5 16 10 12 42 -7 50 -34 13 -108 21 -145 15z"/>
<path d="M1900 1385 c0 -159 9 -197 54 -232 60 -48 167 -36 223 24 l33 34 0
-46 c0 -45 1 -46 28 -43 l27 3 3 203 2 202 -29 0 -29 0 -4 -122 c-4 -138 -14
-170 -67 -205 -58 -39 -133 -27 -164 27 -14 22 -17 55 -17 164 l0 136 -30 0
-30 0 0 -145z"/>
<path d="M3050 1523 c-62 -20 -97 -71 -85 -123 9 -40 40 -63 131 -96 88 -32
108 -56 80 -98 -9 -15 -29 -28 -49 -31 -37 -7 -108 8 -143 31 -21 14 -23 14
-33 -5 -9 -17 -6 -23 19 -41 44 -31 125 -45 179 -31 63 18 91 50 91 105 0 63
-27 91 -119 122 -91 30 -101 38 -101 79 0 24 6 34 25 43 35 16 88 15 130 -2
30 -13 34 -13 39 1 8 19 10 17 -38 37 -37 15 -95 20 -126 9z m117 -19 c-3 -3
-12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z"/>
<path d="M3827 1523 c-4 -3 -7 -96 -7 -205 l0 -199 28 3 27 3 5 137 c6 160 16
183 93 208 37 12 47 20 47 38 0 13 -6 22 -16 22 -28 0 -85 -32 -101 -56 -20
-31 -33 -22 -33 22 0 26 -4 34 -18 34 -10 0 -22 -3 -25 -7z"/>
<path d="M4140 1325 l0 -205 25 0 25 0 0 205 0 205 -25 0 -25 0 0 -205z"/>
<path d="M4370 1250 l0 -281 28 3 27 3 5 113 5 114 24 -26 c34 -37 102 -60
148 -51 118 22 182 107 171 225 -11 107 -72 171 -169 178 -75 6 -101 -1 -143
-39 l-35 -30 -3 33 c-2 28 -7 34 -30 36 l-28 3 0 -281z m300 195 c37 -35 54
-85 47 -137 -6 -46 -42 -103 -75 -117 -37 -17 -114 -13 -148 8 -85 52 -85 209
0 263 48 29 136 21 176 -17z"/>
<path d="M5250 1437 c0 -52 3 -142 7 -200 6 -104 7 -107 30 -107 l23 0 0 200
0 200 -30 0 -30 0 0 -93z"/>
<path d="M5555 1513 c-72 -38 -104 -95 -105 -186 0 -102 47 -164 147 -193 62
-18 97 -13 165 24 107 57 130 212 45 309 -17 20 -46 42 -64 49 -44 19 -151 17
-188 -3z m172 -53 c44 -26 63 -58 70 -118 5 -43 2 -57 -20 -94 -14 -24 -38
-50 -53 -58 -41 -22 -117 -19 -151 6 -85 62 -84 208 2 264 39 26 110 26 152 0z"/>
<path d="M5990 1325 l0 -205 30 0 30 0 0 123 c0 135 11 173 63 211 42 31 121
27 156 -8 25 -26 26 -31 31 -174 l5 -147 28 -3 27 -3 0 156 c0 174 -7 201 -63
235 -22 14 -50 20 -90 20 -65 0 -105 -17 -136 -56 l-21 -27 0 42 c0 39 -2 41
-30 41 l-30 0 0 -205z"/>
<path d="M8445 1516 c-66 -30 -115 -108 -115 -186 0 -146 128 -238 272 -196
30 8 63 25 73 36 17 19 17 22 3 36 -13 14 -18 13 -49 -5 -56 -33 -107 -36
-158 -9 -45 23 -90 86 -76 108 4 6 67 10 167 10 l160 0 -4 54 c-6 67 -42 126
-91 149 -42 20 -140 22 -182 3z m177 -62 c24 -22 51 -81 43 -94 -4 -6 -64 -10
-135 -10 -71 0 -131 4 -135 10 -8 13 18 71 41 92 44 38 143 40 186 2z"/>
<path d="M8850 1325 l0 -205 29 0 29 0 4 134 c3 118 6 138 24 163 23 30 54 49
97 58 21 4 27 11 27 30 0 44 -64 32 -122 -23 l-28 -26 0 37 c0 34 -2 37 -30
37 l-30 0 0 -205z"/>
<path d="M9203 1328 c81 -201 83 -203 112 -203 30 0 31 3 107 190 42 105 77
196 77 203 1 7 -11 12 -26 12 -27 0 -31 -7 -92 -170 -35 -94 -65 -169 -66
-168 -1 2 -31 78 -65 171 l-63 167 -33 0 -32 0 81 -202z"/>
<path d="M9610 1325 l0 -205 30 0 30 0 0 205 0 205 -30 0 -30 0 0 -205z"/>
<path d="M9915 1516 c-66 -29 -115 -113 -115 -196 0 -58 43 -135 92 -166 56
-36 152 -40 212 -8 48 25 66 48 49 65 -9 9 -22 6 -55 -10 -64 -31 -137 -29
-178 5 -47 40 -63 79 -57 137 4 27 13 60 22 74 40 61 128 80 200 43 48 -25 47
-24 62 0 11 17 8 22 -31 45 -34 20 -56 25 -107 25 -35 -1 -78 -7 -94 -14z"/>
<path d="M10355 1513 c-79 -42 -108 -97 -103 -198 4 -82 28 -125 95 -167 52
-32 150 -32 210 0 51 27 60 39 41 59 -13 12 -19 12 -49 -5 -19 -11 -48 -23
-66 -27 -72 -15 -156 36 -169 103 l-6 32 166 0 166 0 0 28 c0 72 -43 147 -101
177 -38 20 -145 19 -184 -2z m159 -43 c30 -11 66 -65 66 -97 0 -23 -2 -23
-136 -23 l-136 0 6 33 c3 18 21 46 41 65 29 27 42 32 84 32 27 0 61 -4 75 -10z"/>
<path d="M3635 1491 c17 -12 25 -21 18 -21 -6 0 -15 5 -18 10 -3 6 -18 10 -33
10 -24 0 -22 -3 17 -20 34 -16 47 -18 58 -9 11 10 11 14 -4 24 -10 7 -29 16
-43 19 -23 7 -23 6 5 -13z"/>
<path d="M3401 1468 c-112 -105 -65 -299 81 -339 70 -18 160 3 201 49 16 17
16 20 2 32 -13 11 -22 10 -54 -8 -75 -42 -172 -23 -211 41 -23 37 -27 134 -8
170 14 28 56 67 70 67 6 0 9 2 6 5 -3 3 -18 1 -33 -5 -25 -9 -26 -9 -15 5 22
27 -4 16 -39 -17z"/>
<path d="M3538 1493 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
</g>
</svg>








    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
